var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 44v-3.5C37 34.149 31.851 29 25.5 29S14 34.149 14 40.5V44h-4v-3.5C10 31.94 16.94 25 25.5 25 34.06 25 41 31.94 41 40.5V44h-4zM25.5 18a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 4a8.5 8.5 0 100-17 8.5 8.5 0 000 17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/Profile-Icon.7178eb802c6cefc5cb9a96bed9715054.svg";
export { ForwardRef as ReactComponent };